import { requestApi } from 'serviceWorker/api/requestApi';
import type { PersonalDataChange } from 'shared/domain/currentUser/currentUserContract';
import type { FailableUserDto } from 'shared/domain/user/types/inDto';
import type { SuperadminUserUpdateDto } from 'shared/domain/user/types/outDto';

/** Saves the logged-in user's label and phone in the organization; resolves with the saved user. */
export function updatePersonalData({ userId, organizationId, personalData }: PersonalDataChange): Promise<FailableUserDto> {
  return requestApi({
    method: 'PUT',
    path: `user/${userId}/personalData/client/${organizationId}`,
    body: personalData,
  });
}

/** Saves the logged-in super admin's label; resolves with the saved user. */
export function updateSuperadminLabel(change: SuperadminUserUpdateDto): Promise<FailableUserDto> {
  return requestApi({ method: 'PUT', path: 'user/me/superadminLabel', body: change });
}
